<template lang="pug">
.bloco-dados-car-vinculados-monitoramento-agricola
    .bloco-dados-territorio--interno
        el-table.estilizacao-tabela(
            :data='cars.slice(0, 2)',
            height='100%',
            style='width: 100%'
        )
            el-table-column(label='CAR', min-width='300px')
                template.teste(slot-scope='scope')
                    span {{ scope.row.codigo }}
            el-table-column(label='Situação do CAR', width='150px')
                template.teste(slot-scope='scope')
                    span.condicao-ativo(v-if='scope.row.condicao === "AT"') {{ validaSituacao(scope.row.condicao) }}
                    span.condicao-pendente(
                        v-else-if='scope.row.condicao === "PE"'
                    ) {{ validaSituacao(scope.row.condicao) }}
                    span.condicao-suspenso(
                        v-else-if='scope.row.condicao === "SU"'
                    ) {{ validaSituacao(scope.row.condicao) }}
                    span.condicao-cancelado(v-else) {{ validaSituacao(scope.row.condicao) }}
                    el-tooltip.item(effect='dark', placement='top-end')
                        div(slot='content')
                            span Status anterior: {{ validaSituacao(scope.row.statusAnterior) }}
                            br
                            span Última atualização: {{ scope.row.dataUltimaAtualizacao }}
                        i.ml-3.flow.flow-warning-sign.laranja(
                            v-if='scope.row.statusAnterior'
                        )
        .tabela-rodape
            .tabela-rodape--esquerda
                span Total de CARs: &nbsp;
                    span {{ cars.length }}
            .tabela-rodape--centralizado
                span Alertas identificados nas situações dos CARs: &nbsp;
                    span {{ monitoramento.totalAlertasCARs }}
            .tabela-rodape--direita
                .abrindo-modal-cars(@click='abreModalCarsVinculados')
                    span.color-inforacao Ver todos
                        i.el-icon-right.color-inforacao

    ModalVisualizacaoCarsVinnculadosMonitoramentoAgricola(
        v-if='showCarsVinculadosAgricola',
        :showCarsVinculadosAgricola='showCarsVinculadosAgricola',
        :cars='this.cars',
        :monitoramento='this.monitoramento'
    )
</template>
<script>
import ModalVisualizacaoCarsVinnculadosMonitoramentoAgricola from '@/components/monitoramento/ModalVisualizacaoCarsVinculadosMonitoramentoAgricola.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'BlocoDadosCarVinculadosMonitoramentoAgricola',
    components: {
        ModalVisualizacaoCarsVinnculadosMonitoramentoAgricola
    },
    props: {
        cars: {
            type: Array,
            required: true,
            default: null
        },
        monitoramento: {
            type: Object,
            required: true,
            default: null
        }
    },

    computed: {
        ...mapGetters(['showCarsVinculadosAgricola'])
    },

    methods: {
        ...mapActions(['changeShowCarsVinculadosAgricolaModal']),

        validaSituacao(situacao) {
            switch (situacao) {
                case 'AT':
                    return 'Ativo';
                case 'PE':
                    return 'Pendente';
                case 'SU':
                    return 'Suspenso';
                case 'CA':
                    return 'Cancelado';
            }
        },

        abreModalCarsVinculados() {
            this.changeShowCarsVinculadosAgricolaModal();
        }
    }
};
</script>
<style lang="scss" scoped>
.bloco-dados-car-vinculados-monitoramento-agricola {
    height: 232px;
    border-radius: 8px;
    background: var(--white);
    display: flex;
    justify-content: flex-start;
    padding: 7px 15px;
    color: var(--primary);

    .bloco-dados-territorio--interno {
        display: flex;
        position: relative;
        width: 100%;

        .estilizacao-tabela {
            height: 100%;
            width: 100%;
            border-bottom: 0px;
            overflow-x: auto;

            .el-table--enable-row-transition .el-table__body td.el-table__cell {
                -webkit-transition: background-color 0.25s ease;
                transition: background-color 0.25s ease;
                border-bottom: hidden !important;
                /* border-top: hidden !important; */
            }
        }
        .bloco-dados-territorio--interno--texto {
            display: flex;
            flex-direction: row;
            min-height: 58px;
            margin-left: 12px;

            span {
                margin-top: 6px;
            }
        }
    }
}

.tabela-rodape {
    font-size: 12px;
    bottom: 0px;
    position: absolute;
    width: -webkit-fill-available;
    height: 10%;
    width: 100%;
    background: var(--white);
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 0 0 5px 5px;

    .tabela-rodape--esquerda p {
        margin-bottom: none;
        color: var(--primary);
        margin: auto;
    }

    .tabela-rodape--direita p {
        margin-bottom: none;
        color: var(--primary);
    }

    .tabela-rodape--centralizado {
        color: var(--primary);
    }
}

.condicao-ativo {
    color: var(--secondary-two);
}

.condicao-pendente {
    color: var(--car-pendente-color);
}

.condicao-suspenso {
    color: var(--car-suspenso-color);
}

.condicao-cancelado {
    color: var(--danger);
}
.abrindo-modal-cars {
    cursor: pointer;
}

.color-inforacao {
    font-weight: 500;
    display: flex;
    color: var(--blue);
    font-size: 14px;
    .el-icon-right.color-inforacao {
        font-size: 16px;
        &:before {
            margin-top: 3px;
        }
    }
    &:hover {
        text-decoration: none;
        color: #0256b1;
    }
}

.laranja {
    color: #f88342;
}
</style>
